import * as React from "react";
import {Fragment} from "react";
import InvoicePaidNotification from "../../../model/notification/invoice/InvoicePaidNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: InvoicePaidNotification;
}

/**
 * Invoice paid notification toast body.
 */
const NotificationInvoicePaidBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Invoice {props.notification.data.jobRefNumber}</div>
			<div className={"toast-body"}>
				Invoice has been paid
			</div>
		</Fragment>
	);
};

export default NotificationInvoicePaidBody;
